<template>
	<div class="relative">
		<div
			v-if="updateAvailable && isVisible"
			class="absolute right-0 top-0 -translate-y-1/4 translate-x-1/4 transform"
		>
			<div
				class="flex items-center justify-center rounded-full"
				:style="{
					width: size,
					height: size,
					backgroundColor: color,
				}"
			></div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { usePWAUpdate } from "@/composables/usePwaUpdate";
	defineProps({
		// Whether the indicator is shown
		isVisible: {
			type: Boolean,
			default: true,
		},
		// Background color of the indicator
		color: {
			type: String,
			default: "red",
		},
		// Size (diameter) of the indicator
		size: {
			type: [String, Number],
			default: "8px",
		},
	});

	const { updateAvailable } = usePWAUpdate();
</script>
